import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../../services/config";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { Paper } from "@material-ui/core";
import { PremissionChecker } from "../../../../services/PremissionChecker";
function DefineSubject() {
  const alert = useAlert();
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");
  const [loading, setloading] = useState(false);
  const [isallfields, setisallfields] = useState(false);

  const [subjectsData, setSubjectsData] = useState([]);
  const [addSubjectLoading, setAddSubjectLoading] = useState(false);

  const [addSubjectModal, setAddSubjectModal] = useState(false);
  const [subjectName, setSubjectName] = useState("");
  const [subjectSlug, setSubjectSlug] = useState("");
  const [weightage, setWeightage] = useState("");
  const [type, setType] = useState(1);
  const [isGrade, setIsGrade] = useState(false);

  const [editSubjectModal, setEditSubjectModal] = useState(false);
  const [editSubjectName, setEditSubjectName] = useState("");
  const [editSubjectSlug, setEditSubjectSlug] = useState("");
  const [editWeightage, setEditWeightage] = useState("");
  const [editSubjectId, setEditSubjectId] = useState("");
  const [editType, setEditType] = useState(1);
  const [EditIsGrade, setEditIsGrade] = useState(false);

  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteSubjectId, setDeleteSubjectId] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    getSubjects();
  }, []);

  const getSubjects = async () => {
    setloading(true);
    await fetch(`${baseUrl}/subject`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setSubjectsData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const addSubjectHandler = async () => {
    if (subjectName == "" || subjectSlug == "" || weightage == "") {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const data = {
      name: subjectName,
      slug: subjectSlug,
      weightage: weightage,
      type: type,
      is_grade: isGrade ? 1 : 0,
    };
    setAddSubjectLoading(true);

    await fetch(`${baseUrl}/subject`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("Subject successfully added");
            setAddSubjectModal(false);
            setAddSubjectLoading(false);
            getSubjects();
            setSubjectName("");
            setSubjectSlug("");
            setWeightage("");
            setType(1);
            setIsGrade(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddSubjectModal(false);
            setAddSubjectLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setAddSubjectModal(false);
            setAddSubjectLoading(false);
          }
        })
      )
      .catch((err) => {
        setAddSubjectLoading(false);
        setAddSubjectModal(false);
        console.log(err);
      });
  };

  const getEditSubject = async (id) => {
    await fetch(`${baseUrl}/subject/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditSubjectName(data.payload?.name);
          setEditSubjectSlug(data.payload?.slug);
          setEditWeightage(
            data.payload?.weightage == null ? "" : data.payload?.weightage
          );
          setEditType(data.payload?.type);
          setEditIsGrade(data.payload?.is_grade);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateSubjectHandler = async () => {
    if (editSubjectName == "") {
      return alert.error("Subject Name Is Required");
    }

    if (editSubjectSlug == "") {
      return alert.error("Subject Slug Is Required");
    }

    if (editWeightage == "") {
      return alert.error("Weightage Is Required");
    }

    setSubmitLoading(true);
    const data = {
      name: editSubjectName,
      slug: editSubjectSlug,
      weightage: editWeightage,
      type: editType,
      is_grade: EditIsGrade ? 1 : 0,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/subject/${editSubjectId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Subject Successfully Updated");
            getSubjects();
            setEditSubjectModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditSubjectModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditSubjectModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deleteSubjectHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/subject/${deleteSubjectId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.payload);
            getSubjects();
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <button
            onClick={() => setAddSubjectModal(true)}
            className="btn btn-primary mr-2"
          >
            Add Subject
          </button>
        </div>

        <Table className="mt-5">
          <thead>
            <tr className="text-center">
              <th>ID</th>
              <th>Subject Name</th>
              <th>Slug</th>
              <th>Weightage</th>
              <th>Type</th>
              <th>Is Grade</th>
              {PremissionChecker(user, "campus.can_change_subject") && (
                <th>Update</th>
              )}
              {PremissionChecker(user, "campus.can_change_subject") && (
                <th>Delete</th>
              )}
            </tr>
          </thead>
          <tbody>
            {subjectsData?.map((subjects, index) => (
              <tr className="text-center" key={index}>
                <td>{subjects.id}</td>
                <td>{subjects.name}</td>
                <td>{subjects.slug}</td>
                <td>{subjects.weightage}</td>
                <td>{subjects.type == 1 ? "Education" : "Hifz"}</td>
                <td>{subjects.is_grade == 1 ? "Yes" : "No"}</td>

                {PremissionChecker(user, "campus.can_change_subject") && (
                  <td>
                    <a
                      className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                      onClick={() => {
                        getEditSubject(subjects?.id);
                        setEditSubjectId(subjects?.id);
                        setEditSubjectModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Write.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>
                )}

                {PremissionChecker(user, "campus.can_change_subject") && (
                  <td>
                    <a
                      className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3"
                      onClick={() => {
                        setDeleteSubjectId(subjects?.id);
                        setdeleteModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-danger">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Delete-user.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        {/* Add SubjectModal */}
        <Modal show={addSubjectModal} size="md">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add New Subject
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Enter Subject Name <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control text-uppercase"
                value={subjectName}
                onChange={(e) => setSubjectName(e.target.value)}
                placeholder="Enter Subject Name"
              />
            </div>

            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Enter Subject Slug <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control text-uppercase"
                value={subjectSlug}
                onChange={(e) => setSubjectSlug(e.target.value)}
                placeholder="Enter Subject Slug"
              />
            </div>

            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Select Weightage <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <select
                onChange={(e) => {
                  setWeightage(e.target.value);
                }}
                className="form-select form-control"
                style={{ height: 40 }}
                value={weightage}
                aria-label="Default select example"
              >
                <option value="">Select Weightage</option>
                <option value="0.5">0.5</option>
                <option value="0.75">0.75</option>
                <option value="1">1</option>
              </select>
            </div>

            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Select Education Type <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <select
                onChange={(e) => {
                  setType(e.target.value);
                }}
                className="form-select form-control"
                style={{ height: 40 }}
                value={type}
                aria-label="Default select example"
              >
                <option value="1">Education</option>
                <option value="2">Hifz</option>
              </select>
            </div>

            <div className="row mb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  checked={isGrade ? isGrade == 1 : false}
                  onChange={(e) => setIsGrade(e.target.checked ? 1 : 0)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Grade Only
              </label>
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please fill or select all fields</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {addSubjectLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addSubjectHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddSubjectModal(false);
                setisallfields(false);
                setSubjectName("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update SubjectModal */}
        <Modal show={editSubjectModal} size="md">
          <Modal.Header>
            <Modal.Title>Update Subject</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Enter Subject Name <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control text-uppercase"
                value={editSubjectName}
                onChange={(e) => setEditSubjectName(e.target.value)}
                placeholder="Enter Subject Name"
              />
            </div>

            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Enter Subject Slug <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control text-uppercase"
                value={editSubjectSlug}
                onChange={(e) => setEditSubjectSlug(e.target.value)}
                placeholder="Enter Subject Slug"
              />
            </div>

            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Select Weightage <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <select
                onChange={(e) => {
                  setEditWeightage(e.target.value);
                }}
                className="form-select form-control"
                style={{ height: 40 }}
                value={editWeightage}
                aria-label="Default select example"
              >
                <option value="">Select Weightage</option>
                <option value="0.5">0.5</option>
                <option value="0.75">0.75</option>
                <option value="1">1</option>
              </select>
            </div>

            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Select Education Type <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <select
                onChange={(e) => {
                  setEditType(e.target.value);
                }}
                className="form-select form-control"
                style={{ height: 40 }}
                value={editType}
                aria-label="Default select example"
              >
                <option value="1">Education</option>
                <option value="2">Hifz</option>
              </select>
            </div>

            <div className="row mb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={EditIsGrade ? EditIsGrade == 1 : false}
                  onChange={(e) => setEditIsGrade(e.target.checked ? 1 : 0)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Grade Only
              </label>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={updateSubjectHandler}
                className="btn btn-primary"
              >
                Update
              </button>
            )}

            <button
              onClick={() => setEditSubjectModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete  Subject Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this subject?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Subject Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deleteSubjectHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default DefineSubject;
